import axios, { AxiosError } from 'axios';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { GET_SEARCH_PROFILE } from '@/constants';

export const useDeleteSearchProfile = (onSuccess: () => void) => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError, { id: number }>({
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['search-profiles'] });
      onSuccess();
    },
    mutationFn: ({ id }) =>
      axios.delete(`${GET_SEARCH_PROFILE}/${id}`).then((res) => {
        return res.data;
      }),
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
};
